module.exports = __webpack_public_path__ + "media/images/icons/flags/SB-316b7686edd636dcbca719a3cda47ae5.svg";